<script setup>
import { useAppStore } from '@/store/main'

const { t } = useI18n()

const store = useAppStore()
const { getProgramNav } = storeToRefs(store)
</script>

<template>
  <section>
    <h1 class="is_c2 text_h1">{{ t('general.program') }}</h1>
    <ClientOnly>
      <div v-if="getProgramNav && getProgramNav.length" class="links">
        <RowLink
          v-for="item in getProgramNav.slice(1)"
          :id="item.id"
          :key="item.id"
          :label="item.label"
          :slug="item.connectedNode ? item.connectedNode.node.slug : item.path"
          :content-type="
            item.connectedNode
              ? item.connectedNode.node.contentType
                ? item.connectedNode.node.contentType.node.name
                : item.connectedNode.node.taxonomy.node.name
              : ''
          "
          root="program"
        />
      </div>

      <div v-else class="links">
        <Loader />
      </div>
    </ClientOnly>
  </section>
</template>

<style scoped lang="scss">
.text_h1 {
  margin-bottom: 130px;
}
.closeRow {
  display: flex;
  flex-flow: row nowrap;
  justify-content: right;
  align-items: center;
  height: 65px;
}
.button {
  margin: 30px auto;
}
.links {
  max-width: 660px;
  margin-right: auto;
}
</style>
